module.exports = __webpack_public_path__ + "img/claim-your-corner-bg.b4512e11.png";